import * as actionTypes from '../actions/actionTypes';
import { roles } from '../../libs/jsonParsers/roles';


import {
    updateObject
} from '../utility';

const initialState = {
    currentRole: 'Select Your Industry',
    currentTxtRole: 'Select Your Industry',
    EXISTING_ROLES: [
        {
            "English": "Select Your Industry",
            "German": "Funktion auswählen",
            "Espanol": "Seleccione su cargo",
            "French": "Quel poste occupez-vous ?",
            "Italian": "Seleziona il tuo ruolo",
            "Russian": "Выберите свою роль",
            "Turkish": "Görevinizi Seçin",
            "Portuguese": "Selecione sua função",
            "SpanishLAD": "Seleccione tu cargo"
        },
        ...roles,
    ],
}

const choose_role = (state, action) => {

    const arrOfRoles = state.EXISTING_ROLES;

    let index;

    arrOfRoles.find(function(obj, idx){                

        if(obj.English === action.role){
            index = idx;
        };  
        
        return;
    });

    // console.log(arrOfRoles);

    return updateObject(state, {
        currentRole: action.role,
        currentTxtRole: arrOfRoles[index][action.lang],        
    });
}

const reducer = (state = initialState, action) => {
    if (action.type === actionTypes.CHOOSE_ROLE) {
        return choose_role(state, action);
    }
    return state;
};

export default reducer;
